import React, { useState } from 'react'
import axios from 'axios'
import { ArrowLongLeftIcon, ArrowPathIcon, EyeSlashIcon, EyeIcon } from '@heroicons/react/24/solid'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import nexus from '../../assets/nexusLogo.png'
import AppFooter from '../../Components/AppFooter'

const ResetPW = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const navigate = useNavigate()
  const [userCredentials, setUserCredentials] = useState({
    newPassword: '',
    confirmNewPassword: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const [toggleShowPw, setToggleShowPw] = useState({
    newPassword: false,
    confirmPassword: false,
  })

  const handleTogglePw = (field) => {
    setToggleShowPw((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }))
  }

  const resetPassword = async () => {
    if (!token) {
      toast.error('Invalid reset token.')
      return
    }

    if (userCredentials.newPassword !== userCredentials.confirmNewPassword) {
      toast.error('Passwords do not match!')
      return
    }

    setIsLoading(true)

    const userCreds = {
      token: token,
      newPassword: userCredentials.newPassword,
      confirmNewPassword: userCredentials.confirmNewPassword,
    }
    axios
      .post('/api/users/auth/reset-password', userCreds)
      .then((response) => {
        toast.success(response.data.message)
        setTimeout(() => navigate('/login'), 2000)
      })
      .catch((error) => {
        console.error('Error:', error)
        const errorMessage = error.response?.data?.message || 'An error occurred.'
        toast.error(errorMessage)
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <>
      <div className="nx-app-bg flex min-h-screen w-full flex-col px-4 pb-4">
        <div className="flex flex-1 items-center justify-center py-6">
          <div className="nx-panel w-full max-w-md p-8">
          <p className="nx-manifest-kicker">Account recovery</p>
          <div className="my-6 flex items-center gap-2">
            <div className="h-10 w-44">
              <img src={nexus} className="h-full w-full object-contain object-left" alt="Nexus V2" />
            </div>
            <span className="rounded-md border border-signal/40 bg-signal/10 px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-wider text-signal">
              V2
            </span>
          </div>
          <h1 className="font-display text-3xl tracking-wide text-paper">Set a new password</h1>
          <p className="mt-2 text-sm text-muted">Choose a new password for your Nexus V2 account.</p>

          <form
            className="mt-6 space-y-4"
            onSubmit={(e) => {
              e.preventDefault()
              resetPassword()
            }}
          >
            <div>
              <label htmlFor="newPassword" className="nx-label">
                New password
              </label>
              <div className="relative">
                <input
                  id="newPassword"
                  className="nx-input pr-10"
                  name="password"
                  type={toggleShowPw.newPassword ? 'text' : 'password'}
                  required
                  onChange={(e) =>
                    setUserCredentials({ ...userCredentials, newPassword: e.target.value })
                  }
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-paper"
                  onClick={() => handleTogglePw('newPassword')}
                  aria-label="Toggle new password visibility"
                >
                  {toggleShowPw.newPassword ? (
                    <EyeSlashIcon className="h-5 w-5" />
                  ) : (
                    <EyeIcon className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>

            <div>
              <label htmlFor="confirmNewPassword" className="nx-label">
                Confirm new password
              </label>
              <div className="relative">
                <input
                  id="confirmNewPassword"
                  className="nx-input pr-10"
                  name="password"
                  type={toggleShowPw.confirmPassword ? 'text' : 'password'}
                  required
                  onChange={(e) =>
                    setUserCredentials({
                      ...userCredentials,
                      confirmNewPassword: e.target.value,
                    })
                  }
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-paper"
                  onClick={() => handleTogglePw('confirmPassword')}
                  aria-label="Toggle confirm password visibility"
                >
                  {toggleShowPw.confirmPassword ? (
                    <EyeSlashIcon className="h-5 w-5" />
                  ) : (
                    <EyeIcon className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>

            <button className="nx-btn-primary" type="submit" disabled={isLoading}>
              {isLoading ? (
                <span className="flex items-center gap-2">
                  Confirm
                  <ArrowPathIcon className="h-4 w-4 animate-spin" />
                </span>
              ) : (
                'Confirm'
              )}
            </button>
          </form>

          <Link to="/login" className="mt-8 inline-flex items-center gap-2 text-sm text-muted hover:text-signal">
            <ArrowLongLeftIcon className="h-4 w-4" />
            Back to login
          </Link>
          </div>
        </div>
        <AppFooter className="mx-auto w-full max-w-7xl" />
      </div>
    </>
  )
}

export default ResetPW
